import React, { cloneElement, useState } from "react"
import { URL_Back } from "./../Variables";

const jsonToFormData = (json) => {
  try {
    const data = new FormData()

    for (let k in json) {
      data.append(k, json[k])
    }
    return data
  } catch (error) {
    console.error(error)
    return null
  }
}

const ErrorMessage = () => {
  return (
    <div style={{ color: "red" }}>
      <strong>url</strong> or <strong>siteUrl</strong> and{" "}
      <strong>formId</strong> are mandatory attributes
    </div>
  )
}

const Cf7FormWrapper = ({ children, siteUrl, formId, id }) => {
  const [issent, setSent] = useState(false)
  const [isloading, setLoading] = useState(false)
  const [haserror, setError] = useState(null)

  const apiUrl = `${URL_Back}` + "/wp-json/contact-form-7/v1/contact-forms/" + id + "/feedback/";

  const normalizeMessage = (msg) => {
    if (!msg || typeof msg !== "string") return "Réessayez plus tard"
    return msg.replace(/[\s.]*\d+$/, "").trim()
  }

  const formSubmitHandler = (event, payload) => {
    event.preventDefault()

    setLoading(true)
    setError(null)

    const safePayload = payload || {}
    const unitTag = safePayload._wpcf7_unit_tag
      ? safePayload._wpcf7_unit_tag
      : `wpcf7-f${id}-p0-o1`
    const formPayload = {
      ...safePayload,
      _wpcf7: safePayload._wpcf7 ? safePayload._wpcf7 : id,
      _wpcf7_unit_tag: unitTag,
    }

    fetch(apiUrl, {
      method: "POST",
      body: jsonToFormData(formPayload),
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.status !== "mail_sent") {
          throw normalizeMessage(resp.message)
        }
        setSent(true)
      })
      .catch((error) => {
        setSent(false)
        setError(normalizeMessage(error))
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const Form = cloneElement(children, {
    handler: formSubmitHandler,
    isloading,
    issent,
    haserror,
  })

  return <div>{id || (siteUrl && formId) ? Form : <ErrorMessage />}</div>
}

export default Cf7FormWrapper
